import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { DocumentoFormComponent } from './documento-form/documento-form.component';
import { DocumentoListComponent } from './documento-list/documento-list.component';
import { DocumentoModalComponent } from './documento-modal/documento-modal.component';

@NgModule({
  declarations: [
    DocumentoFormComponent,
    DocumentoListComponent,
    DocumentoModalComponent
  ],
  exports:[
    DocumentoFormComponent,
    DocumentoListComponent,
    DocumentoModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgxMaskDirective,
    NgxMaskPipe
  ],
  providers: [
    provideNgxMask()
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DocumentoModule { }
